import Media from ".";

export const mediaRoutes = () => [
  {
    path: "/admin/media",
    component: Media,
    layout: "admin",
    routeType: "admin",
    title: "Media Management",
  },
];
